import { ITaskCondition, ITaskConditions } from 'types/flows';

export enum AtomicChangeInitType {
	target,
	operator
}

export interface IOnConditionChange {
	type: AtomicChangeInitType;
	val: string;
	taskIndex: number;
	condIndex: number;
}

export type ConditionChangeCallback = (props: IOnConditionChange) => void;

export interface IValues {
	taskName: string;
	taskConditions: ITaskConditions;
	elseName: ITaskCondition | string;
}
